import { createFileRoute } from '@tanstack/react-router'
import AccountingTransactions from '@/features/accounting-transactions'

export const Route = createFileRoute('/_authenticated/accounting-transaction/')({
  component: AccountingTransactions,
}) 